import type { User } from 'firebase/auth';
import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '@/services';

export function useTutorials(user: User | null) {
  const queryClient = useQueryClient();

  const { data: tutorials, isLoading } = useQuery({
    queryKey: ['userTutorials', user?.uid],
    queryFn: () => (user ? settingsService.getTutorials(user.uid) : null),
    enabled: !!user,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!user) return;

    const unsubscribe = settingsService.subscribeToTutorials(user.uid, updated => {
      queryClient.setQueryData(['userTutorials', user.uid], updated);
    });

    return () => unsubscribe();
  }, [user, queryClient]);

  return { tutorials: tutorials ?? null, isLoading };
}
